import * as React from 'react'
import { useCallback } from 'react'
import MenuItem from '@mui/material/MenuItem'

import type { ScheduleMode } from '../../typings'
import { modeToButtonLabel } from '../../utils'
import {
  useSchedulingWizard,
  openActionCreator as open,
  setRequireACWOppSchedulingActionCreator as setRequiredACW,
} from '../wizardContext'

type ScheduleMenuItemProps = {
  entityId: number
  required?: boolean
  disabled?: boolean
  mode: ScheduleMode
  requireACWOppScheduling?: boolean
  onClose?: () => void
}

export function ScheduleMenuItem(props: ScheduleMenuItemProps) {
  const {
    mode,
    required,
    disabled,
    entityId,
    requireACWOppScheduling,
    onClose,
  } = props

  const label = modeToButtonLabel(mode, required)
  const dataTestId = `${entityId}-${mode}-menuItem`

  const [, dispatch] = useSchedulingWizard()

  const onClick = useCallback(() => {
    if (onClose) {
      onClose()
    }
    dispatch(open(mode, 'locAndSvcs'))

    if (requireACWOppScheduling) dispatch(setRequiredACW(true))
  }, [dispatch, mode, requireACWOppScheduling, onClose])

  return (
    <MenuItem onClick={onClick} data-test-id={dataTestId} disabled={disabled}>
      {label}
    </MenuItem>
  )
}
